import { render, staticRenderFns } from "./ResetPasswordConfirmation.vue?vue&type=template&id=2a523746&scoped=true&"
import script from "./ResetPasswordConfirmation.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordConfirmation.vue?vue&type=style&index=0&id=2a523746&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a523746",
  null
  
)

export default component.exports